import { defaultPagination, Pagination as PaginationType } from 'aa_common/front-end/zustand/helper'
import { PaginationProps, Space } from 'antd'
import produce from 'immer'
import { useCallback } from 'react'

import { detailReportSlice } from '../store'

export const usePagination = () => {
  const getPagination = useCallback((_pagination?: PaginationType, unit?: string) => {
    const { total, current, pageSize } = _pagination || {}
    const itemRender: PaginationProps['itemRender'] = (current, type, originalElement) => {
      if (type === 'next') {
        return !total ? (
          originalElement
        ) : (
          <Space>
            <span>{unit}</span>
            {originalElement}
          </Space>
        )
      }
      return originalElement
    }

    const pagination: PaginationProps = {
      simple: true,
      current,
      ...(pageSize ? { pageSize } : {}),
      ...(total ? { total } : {}),
      itemRender,
      onChange: (page: number) => {
        detailReportSlice.setFilters(
          prevFilter =>
            produce(prevFilter, d => {
              if (!d.pagination) d.pagination = defaultPagination
              d.pagination.current = page
            }),
          true
        )
      },
    }
    return pagination
  }, [])

  return { getPagination }
}
